import React from 'react'


export default function Spec({title, spec}) {
 

  return (
    <div><h3>{title}</h3>
    <div>{spec}</div>
    </div>
  )
}
